export default __webpack_public_path__ + "static/media/Ekierka-02.afd75c11.svg";